import React, { useEffect } from 'react';
import { Typography } from 'antd';
import PublicHeader from '../../components/Public/PublicHeader';
import PublicFooter from '../../components/Public/PublicFooter';
import LegalDocumentsRegistryWidget from '../../components/Legal/LegalDocumentsRegistryWidget';
import useSEO from '../../hooks/useSEO';
import seoService from '../../services/seo.service';
import { getLegalPublicBaseUrl } from '../../utils/legalPublicUrls';
/* STYLESYSTEM/pages/public-marketing.css */

const { Title } = Typography;

export default function LegalHubPage() {
  useSEO('legal', null, {
    title: 'Правовые документы — Markbase',
    description: 'Реестр актуальных документов оператора персональных данных: политика конфиденциальности, условия, cookie и согласия.',
  });

  useEffect(() => {
    const base = getLegalPublicBaseUrl();
    seoService.injectJsonLd([
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'Правовые документы Markbase',
        url: `${base}/legal`,
        inLanguage: 'ru-RU',
        isPartOf: { '@type': 'WebSite', name: 'Markbase', url: base },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'PrivacyPolicy',
        name: 'Политика конфиденциальности Markbase',
        url: `${base}/privacy`,
      },
    ]);
    return () => seoService.removeJsonLd();
  }, []);

  return (
    <div className="public-page">
      <PublicHeader />
      <section className="page-hero">
        <div className="container">
          <Title level={1} style={{ marginBottom: 8 }}>
            Правовые документы
          </Title>
        </div>
      </section>
      <section className="content-section">
        <div className="container" style={{ maxWidth: 800 }}>
          <LegalDocumentsRegistryWidget />
        </div>
      </section>
      <PublicFooter />
    </div>
  );
}
